var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiBusStop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:bus-stop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5625 1.875H2.8125V28.125H6.5625V1.875Z",
    fill: "url(#paint0_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5625 1.875H2.8125V28.125H6.5625V1.875Z",
    fill: "url(#paint1_radial_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.5625 1.875H2.8125V28.125H6.5625V1.875Z",
    fill: "url(#paint2_radial_434_3122)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_f_434_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.6875 2.95508H5.70656V27.3404H4.6875V2.95508Z",
    fill: "url(#paint3_linear_434_3122)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.5625 1.875H2.8125V28.125H6.5625V1.875Z",
    fill: "url(#paint4_radial_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.5625 1.875H2.8125V28.125H6.5625V1.875Z",
    fill: "url(#paint5_radial_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.58814 9.375H2.72439C2.61242 9.37513 2.50153 9.35309 2.39812 9.31015C2.2947 9.26722 2.20081 9.20424 2.12185 9.12485C2.04289 9.04545 1.98043 8.95121 1.93807 8.84757C1.8957 8.74392 1.87428 8.63291 1.87502 8.52094V6.47812C1.87502 6.00469 2.25283 5.625 2.72439 5.625H7.58814C8.05971 5.625 8.43752 6.00469 8.43752 6.47906V8.51063C8.43851 8.62315 8.41732 8.73477 8.37517 8.83911C8.33302 8.94345 8.27073 9.03847 8.19186 9.11873C8.11299 9.199 8.01908 9.26294 7.91549 9.30691C7.8119 9.35088 7.70067 9.37402 7.58814 9.375Z",
    fill: "url(#paint6_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.58814 9.375H2.72439C2.61242 9.37513 2.50153 9.35309 2.39812 9.31015C2.2947 9.26722 2.20081 9.20424 2.12185 9.12485C2.04289 9.04545 1.98043 8.95121 1.93807 8.84757C1.8957 8.74392 1.87428 8.63291 1.87502 8.52094V6.47812C1.87502 6.00469 2.25283 5.625 2.72439 5.625H7.58814C8.05971 5.625 8.43752 6.00469 8.43752 6.47906V8.51063C8.43851 8.62315 8.41732 8.73477 8.37517 8.83911C8.33302 8.94345 8.27073 9.03847 8.19186 9.11873C8.11299 9.199 8.01908 9.26294 7.91549 9.30691C7.8119 9.35088 7.70067 9.37402 7.58814 9.375Z",
    fill: "url(#paint7_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.58814 9.375H2.72439C2.61242 9.37513 2.50153 9.35309 2.39812 9.31015C2.2947 9.26722 2.20081 9.20424 2.12185 9.12485C2.04289 9.04545 1.98043 8.95121 1.93807 8.84757C1.8957 8.74392 1.87428 8.63291 1.87502 8.52094V6.47812C1.87502 6.00469 2.25283 5.625 2.72439 5.625H7.58814C8.05971 5.625 8.43752 6.00469 8.43752 6.47906V8.51063C8.43851 8.62315 8.41732 8.73477 8.37517 8.83911C8.33302 8.94345 8.27073 9.03847 8.19186 9.11873C8.11299 9.199 8.01908 9.26294 7.91549 9.30691C7.8119 9.35088 7.70067 9.37402 7.58814 9.375Z",
    fill: "url(#paint8_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.58816 21.5625H2.72441C2.61223 21.5625 2.50117 21.5403 2.39762 21.4971C2.29408 21.454 2.20011 21.3907 2.12114 21.3111C2.04217 21.2314 1.97976 21.1369 1.93752 21.033C1.89528 20.9291 1.87404 20.8178 1.87503 20.7056V18.6694C1.87503 18.1931 2.25285 17.8125 2.72441 17.8125H7.58816C8.05972 17.8125 8.43753 18.1931 8.43753 18.6694V20.7056C8.43779 20.9317 8.34862 21.1486 8.18949 21.3092C8.03036 21.4697 7.81419 21.5608 7.58816 21.5625Z",
    fill: "url(#paint9_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.58816 21.5625H2.72441C2.61223 21.5625 2.50117 21.5403 2.39762 21.4971C2.29408 21.454 2.20011 21.3907 2.12114 21.3111C2.04217 21.2314 1.97976 21.1369 1.93752 21.033C1.89528 20.9291 1.87404 20.8178 1.87503 20.7056V18.6694C1.87503 18.1931 2.25285 17.8125 2.72441 17.8125H7.58816C8.05972 17.8125 8.43753 18.1931 8.43753 18.6694V20.7056C8.43779 20.9317 8.34862 21.1486 8.18949 21.3092C8.03036 21.4697 7.81419 21.5608 7.58816 21.5625Z",
    fill: "url(#paint10_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.58816 21.5625H2.72441C2.61223 21.5625 2.50117 21.5403 2.39762 21.4971C2.29408 21.454 2.20011 21.3907 2.12114 21.3111C2.04217 21.2314 1.97976 21.1369 1.93752 21.033C1.89528 20.9291 1.87404 20.8178 1.87503 20.7056V18.6694C1.87503 18.1931 2.25285 17.8125 2.72441 17.8125H7.58816C8.05972 17.8125 8.43753 18.1931 8.43753 18.6694V20.7056C8.43779 20.9317 8.34862 21.1486 8.18949 21.3092C8.03036 21.4697 7.81419 21.5608 7.58816 21.5625Z",
    fill: "url(#paint11_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_ii_434_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.61406 23.4375H25.0734C25.634 23.437 26.1714 23.2141 26.5678 22.8178C26.9641 22.4214 27.187 21.884 27.1875 21.3234V5.86406C27.187 5.30353 26.9641 4.7661 26.5678 4.36974C26.1714 3.97339 25.634 3.7505 25.0734 3.75H9.61406C9.05353 3.7505 8.5161 3.97339 8.11974 4.36974C7.72339 4.7661 7.5005 5.30353 7.5 5.86406V21.3234C7.5005 21.884 7.72339 22.4214 8.11974 22.8178C8.5161 23.2141 9.05353 23.437 9.61406 23.4375Z",
    fill: "url(#paint12_linear_434_3122)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.61406 23.4375H25.0734C25.634 23.437 26.1714 23.2141 26.5678 22.8178C26.9641 22.4214 27.187 21.884 27.1875 21.3234V5.86406C27.187 5.30353 26.9641 4.7661 26.5678 4.36974C26.1714 3.97339 25.634 3.7505 25.0734 3.75H9.61406C9.05353 3.7505 8.5161 3.97339 8.11974 4.36974C7.72339 4.7661 7.5005 5.30353 7.5 5.86406V21.3234C7.5005 21.884 7.72339 22.4214 8.11974 22.8178C8.5161 23.2141 9.05353 23.437 9.61406 23.4375Z",
    fill: "url(#paint13_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M9.61406 23.4375H25.0734C25.634 23.437 26.1714 23.2141 26.5678 22.8178C26.9641 22.4214 27.187 21.884 27.1875 21.3234V5.86406C27.187 5.30353 26.9641 4.7661 26.5678 4.36974C26.1714 3.97339 25.634 3.7505 25.0734 3.75H9.61406C9.05353 3.7505 8.5161 3.97339 8.11974 4.36974C7.72339 4.7661 7.5005 5.30353 7.5 5.86406V21.3234C7.5005 21.884 7.72339 22.4214 8.11974 22.8178C8.5161 23.2141 9.05353 23.437 9.61406 23.4375Z",
    fill: "url(#paint14_radial_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M22.0044 15.9329H21.0312C20.7724 15.9329 20.5625 16.1427 20.5625 16.4016V19.2188C20.5625 19.4777 20.7724 19.6875 21.0312 19.6875H22.0044C22.2633 19.6875 22.4731 19.4777 22.4731 19.2188V16.4016C22.4731 16.1427 22.2633 15.9329 22.0044 15.9329Z",
    fill: "url(#paint15_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.6548 15.9329H12.6816C12.4228 15.9329 12.2129 16.1427 12.2129 16.4016V19.2188C12.2129 19.4777 12.4228 19.6875 12.6816 19.6875H13.6548C13.9136 19.6875 14.1235 19.4777 14.1235 19.2188V16.4016C14.1235 16.1427 13.9136 15.9329 13.6548 15.9329Z",
    fill: "url(#paint16_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M22.2168 12.2783H23.2968V13.1858H22.2168V12.2783Z",
    fill: "url(#paint17_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M11.6738 12.2783H12.7538V13.1858H11.6738V12.2783Z",
    fill: "url(#paint18_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.2129 9.14063C12.2129 8.7428 12.3709 8.36127 12.6522 8.07997C12.9335 7.79866 13.3151 7.64062 13.7129 7.64062H20.9738C21.1708 7.64062 21.3659 7.67942 21.5479 7.75481C21.7298 7.83019 21.8952 7.94068 22.0345 8.07997C22.1738 8.21925 22.2843 8.38461 22.3596 8.5666C22.435 8.74859 22.4738 8.94364 22.4738 9.14063V17.5716C22.4738 17.6701 22.4544 17.7676 22.4167 17.8586C22.379 17.9496 22.3238 18.0322 22.2542 18.1019C22.1845 18.1715 22.1018 18.2268 22.0108 18.2645C21.9198 18.3022 21.8223 18.3216 21.7238 18.3216H12.9629C12.8644 18.3216 12.7669 18.3022 12.6759 18.2645C12.5849 18.2268 12.5022 18.1715 12.4326 18.1019C12.3629 18.0322 12.3077 17.9496 12.27 17.8586C12.2323 17.7676 12.2129 17.6701 12.2129 17.5716V9.13969V9.14063Z",
    fill: "url(#paint19_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M23.5583 11.3467H23.1992C23.0439 11.3467 22.918 11.4726 22.918 11.6279V13.3773C22.918 13.5326 23.0439 13.6586 23.1992 13.6586H23.5583C23.7136 13.6586 23.8395 13.5326 23.8395 13.3773V11.6279C23.8395 11.4726 23.7136 11.3467 23.5583 11.3467Z",
    fill: "url(#paint20_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.55,
    d: "M11.488 11.3467H11.1289C10.9736 11.3467 10.8477 11.4726 10.8477 11.6279V13.3773C10.8477 13.5326 10.9736 13.6586 11.1289 13.6586H11.488C11.6433 13.6586 11.7692 13.5326 11.7692 13.3773V11.6279C11.7692 11.4726 11.6433 11.3467 11.488 11.3467Z",
    fill: "#C86464",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M11.488 11.3467H11.1289C10.9736 11.3467 10.8477 11.4726 10.8477 11.6279V13.3773C10.8477 13.5326 10.9736 13.6586 11.1289 13.6586H11.488C11.6433 13.6586 11.7692 13.5326 11.7692 13.3773V11.6279C11.7692 11.4726 11.6433 11.3467 11.488 11.3467Z",
    fill: "url(#paint21_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M22.4738 14.9709V17.5716C22.4738 17.6701 22.4544 17.7676 22.4167 17.8586C22.379 17.9496 22.3238 18.0323 22.2542 18.1019C22.1845 18.1715 22.1018 18.2268 22.0108 18.2645C21.9198 18.3022 21.8223 18.3216 21.7238 18.3216H12.9629C12.8644 18.3216 12.7669 18.3022 12.6759 18.2645C12.5849 18.2268 12.5022 18.1715 12.4326 18.1019C12.3629 18.0323 12.3077 17.9496 12.27 17.8586C12.2323 17.7676 12.2129 17.6701 12.2129 17.5716V14.9709H22.4738Z",
    fill: "url(#paint22_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M21.0515 9.01611H13.6387C13.3798 9.01611 13.1699 9.22598 13.1699 9.48486V14.1274C13.1699 14.3862 13.3798 14.5961 13.6387 14.5961H21.0515C21.3104 14.5961 21.5202 14.3862 21.5202 14.1274V9.48486C21.5202 9.22598 21.3104 9.01611 21.0515 9.01611Z",
    fill: "url(#paint23_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M21.5193 10.4111H13.1699V9.48486C13.1699 9.36054 13.2193 9.24132 13.3072 9.15341C13.3951 9.0655 13.5144 9.01611 13.6387 9.01611H21.0505C21.1749 9.01611 21.2941 9.0655 21.382 9.15341C21.4699 9.24132 21.5193 9.36054 21.5193 9.48486V10.4111Z",
    fill: "url(#paint24_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M19.9048 15.5127H14.8133C14.6813 15.5127 14.5742 15.6197 14.5742 15.7518C14.5742 15.8838 14.6813 15.9908 14.8133 15.9908H19.9048C20.0369 15.9908 20.1439 15.8838 20.1439 15.7518C20.1439 15.6197 20.0369 15.5127 19.9048 15.5127Z",
    fill: "url(#paint25_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M18.958 16.4485H15.7293C15.5973 16.4485 15.4902 16.5555 15.4902 16.6875C15.4902 16.8196 15.5973 16.9266 15.7293 16.9266H18.958C19.0901 16.9266 19.1971 16.8196 19.1971 16.6875C19.1971 16.5555 19.0901 16.4485 18.958 16.4485Z",
    fill: "url(#paint26_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M12.2129 17.3755V15.5127H13.1588C13.2831 15.5127 13.4024 15.5621 13.4903 15.65C13.5782 15.7379 13.6276 15.8571 13.6276 15.9814V16.9068C13.6276 17.0311 13.5782 17.1503 13.4903 17.2382C13.4024 17.3261 13.2831 17.3755 13.1588 17.3755H12.2129Z",
    fill: "url(#paint27_linear_434_3122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M22.4752 17.3755V15.5127H21.5293C21.405 15.5127 21.2857 15.5621 21.1978 15.65C21.1099 15.7379 21.0605 15.8571 21.0605 15.9814V16.9068C21.0605 17.0311 21.1099 17.1503 21.1978 17.2382C21.2857 17.3261 21.405 17.3755 21.5293 17.3755H22.4752Z",
    fill: "url(#paint28_linear_434_3122)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_434_3122",
    x: 3.1875,
    y: 1.45508,
    width: 4.01953,
    height: 27.3853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_434_3122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_434_3122",
    x: 6.25,
    y: 2.5,
    width: 22.1875,
    height: 22.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.25,
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.65098 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3122"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.25,
    dy: -1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.32549 0 0 0 0 0.572549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3122",
    result: "effect2_innerShadow_434_3122"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_3122",
    x1: 2.81531,
    y1: 15.0037,
    x2: 5.70656,
    y2: 15.0037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8BA1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_434_3122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.28625 1.875) rotate(104.295) scale(4.72943 3.341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC9D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_434_3122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.48469 30.5691) rotate(-116.565) scale(9.67679 5.82014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEA1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEA1BE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_434_3122",
    x1: 5.19656,
    y1: 2.95508,
    x2: 5.19656,
    y2: 27.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1BEC8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_434_3122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.6875 8.49563) rotate(90) scale(1.81448 3.59945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#645775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645775",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_434_3122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.6875 20.3934) rotate(90) scale(2.52651 5.01189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#645775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645775",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_434_3122",
    x1: 1.86939,
    y1: 7.49906,
    x2: 6.53908,
    y2: 7.49906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A8BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_434_3122",
    x1: 5.15627,
    y1: 5.625,
    x2: 5.15627,
    y2: 6.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8C96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8C96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_434_3122",
    x1: 5.86221,
    y1: 9.85969,
    x2: 5.86221,
    y2: 8.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#625275",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_434_3122",
    x1: 1.86941,
    y1: 19.6866,
    x2: 6.5391,
    y2: 19.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A8BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_434_3122",
    x1: 5.15628,
    y1: 17.8125,
    x2: 5.15628,
    y2: 18.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8C96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8C96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_434_3122",
    x1: 5.86222,
    y1: 22.0472,
    x2: 5.86222,
    y2: 20.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#625275",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_434_3122",
    x1: 10.6059,
    y1: 21.9731,
    x2: 25.8403,
    y2: 5.39062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C7BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3893E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_434_3122",
    x1: 17.3438,
    y1: 24.0825,
    x2: 17.3438,
    y2: 21.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3054C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3054C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_434_3122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9817 4.16072) rotate(130.192) scale(2.22444 1.8548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#52BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52BBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_434_3122",
    x1: 20.5625,
    y1: 18.8766,
    x2: 22.4741,
    y2: 18.8766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_434_3122",
    x1: 12.2129,
    y1: 18.8766,
    x2: 14.1245,
    y2: 18.8766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_434_3122",
    x1: 22.469,
    y1: 12.6336,
    x2: 22.9124,
    y2: 12.6336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453A4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_434_3122",
    x1: 11.7554,
    y1: 12.6336,
    x2: 12.136,
    y2: 12.6336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453A4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_434_3122",
    x1: 12.9235,
    y1: 7.63969,
    x2: 23.3232,
    y2: 16.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDCDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_434_3122",
    x1: 22.9827,
    y1: 12.2532,
    x2: 23.8405,
    y2: 12.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_434_3122",
    x1: 10.9123,
    y1: 12.2532,
    x2: 11.7702,
    y2: 12.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_434_3122",
    x1: 13.3126,
    y1: 14.9709,
    x2: 20.0073,
    y2: 18.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2A53E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_434_3122",
    x1: 13.1699,
    y1: 11.4667,
    x2: 21.5193,
    y2: 11.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57D4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_434_3122",
    x1: 13.1699,
    y1: 9.71361,
    x2: 21.5193,
    y2: 9.71361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A436E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_434_3122",
    x1: 14.5742,
    y1: 15.7508,
    x2: 20.1439,
    y2: 15.7508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68606D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_434_3122",
    x1: 15.4902,
    y1: 16.6875,
    x2: 19.1971,
    y2: 16.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68606D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_434_3122",
    x1: 12.2129,
    y1: 16.7483,
    x2: 13.4654,
    y2: 16.7483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B8D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DECEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_434_3122",
    x1: 21.0605,
    y1: 16.4436,
    x2: 22.7752,
    y2: 16.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B8D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DECEE6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiBusStop);
export default __webpack_public_path__ + "static/media/fluent-emoji_bus-stop.10956dcc64d2080f4cbdd3b3570bf372.svg";
export { ForwardRef as ReactComponent };